module.exports =
  站: "site"
  面: "page"
  块: "block"
  条: "row"
  丁: "label"
  口: "link"
  图: "image"
  影: "video"
  集: "set"
  箱: "box"
  件: "item"


